module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_6.b8f84b2c.jpg";